export default "__VITE_ASSET__CYGBYZzy__"